import React, { Component } from 'react';
import { ButtonEditContainerButton } from './styles';

class ButtonEdit extends Component {
    constructor(props){
        super(props)
    }

    render() {
        return (
            <ButtonEditContainerButton data={this.props.idbilling} onClick={(e)=>this.props.selectBilling(e)}>
                <span data={this.props.idbilling} className="icon icon-25 icon-edit-green"></span>
                <p data={this.props.idbilling}>Editar</p>
            </ButtonEditContainerButton>
        );
    }
}

export default ButtonEdit;
